const config = {
  api: process.env.REACT_APP_BASE_URL_API,
  env: process.env.REACT_APP_NODE_ENV,
  baseName: process.env.REACT_APP_BASE_NAME,
  baseUrl: process.env.REACT_APP_BASE_URL,
  baseCountryId: process.env.REACT_APP_BASE_COUNTRY_ID,
};

export default config;
